import defaultImg from "@/assets/app.png";
import { openApp } from "@/libs/common";
import Phead from "../components/Layout/Head";
import Apps from "@/components/AppTemplate/Apps";
import UnitSelect from "@/views/MGT/AppList/UnitSelect.vue";
import OpenAppModal from "@/views/OpenApp.vue";
export default {
  name: "Applist",
  components: {
    Phead,
    Apps,
    UnitSelect,
    OpenAppModal
  },
  data() {
    return {
      defaultImg
    };
  },
  methods: {
    jump(item) {
      openApp(this, item);
    }
  }
};